module.exports = __webpack_public_path__ + "img/REGISTRO 4.1c0685e8.png";